import { ErrorMessage } from 'components/Form/components/ErrorMessage';
import { composeValidators } from 'components/Form/validate';
import { Message } from 'models';
import React from 'react';
import { Field } from 'react-final-form';

import * as S from './textarea.styles';

interface TextareaProps {
  name: string;
  id?: string;
  label?: string;
  validate?: Array<(inputValue: unknown) => undefined | Message>;
  isRequired?: boolean;
  placeholder?: string;
  maxLength?: number;
  rows?: number;
  textareaRef?: React.Ref<HTMLTextAreaElement>;
}

export const TextArea = (props: TextareaProps) => {
  const { name, label, validate, rows = 5, isRequired, textareaRef, ...rest } = props;
  // Random ID is generated if id is not set (this way labels will stay accessible).
  const id = props.id || crypto.randomUUID();

  const getValue = (inputValue: unknown) => {
    if (typeof inputValue === 'string' || typeof inputValue === 'number') {
      return inputValue;
    }
    if (inputValue === undefined || inputValue === null) {
      return '';
    }
    return String(inputValue);
  };

  return (
    <>
      {label && (
        <S.Label htmlFor={id}>
          {label} {isRequired && <span> *</span>}
        </S.Label>
      )}
      <Field
        name={name}
        validate={validate ? composeValidators(validate) : undefined}
        render={({ input, meta }) => (
          <React.Fragment>
            <S.Textarea {...input} value={getValue(input.value)} rows={rows} id={id} ref={textareaRef} {...rest} />
            {meta.error && meta.touched && <ErrorMessage message={meta.error} />}
          </React.Fragment>
        )}
      />
    </>
  );
};
